export type NaturalHistoryField = 'sex' | 'age_class' | 'behavior';

const FIELD_LABELS = {
    'pt-BR': {
        sex: 'Sexo',
        age_class: 'Faixa etária',
        behavior: 'Comportamento',
    },
    fr: {
        sex: 'Sexe',
        age_class: "Classe d'âge",
        behavior: 'Comportement',
    },
};

const LABELS = {
    'pt-BR': {
        sex: {
            nao_informado: 'Não identificado',
            macho: 'Macho',
            femea: 'Fêmea',
            grupo: 'Grupo / múltiplos sexos',
        },
        age_class: {
            nao_informado: 'Não informado',
            filhote: 'Filhote',
            jovem: 'Jovem',
            adulto: 'Adulto',
            mistas: 'Múltiplas idades',
        },
        behavior: {
            nao_informado: 'Não informado',
            deslocamento: 'Deslocamento',
            alimentacao: 'Alimentação',
            descanso: 'Descanso',
            interacao_social: 'Interação social',
            vocalizacao: 'Vocalização',
            reproducao: 'Reprodução',
            outro: 'Outro',
        },
    },
    fr: {
        sex: {
            nao_informado: 'Non identifié',
            macho: 'Mâle',
            femea: 'Femelle',
            grupo: 'Groupe / plusieurs sexes',
        },
        age_class: {
            nao_informado: 'Non renseigné',
            filhote: 'Petit',
            jovem: 'Jeune',
            adulto: 'Adulte',
            mistas: 'Âges multiples',
        },
        behavior: {
            nao_informado: 'Non renseigné',
            deslocamento: 'Déplacement',
            alimentacao: 'Alimentation',
            descanso: 'Repos',
            interacao_social: 'Interaction sociale',
            vocalizacao: 'Vocalisation',
            reproducao: 'Reproduction',
            outro: 'Autre',
        },
    },
};

export function getNaturalHistoryFieldLabel(
    field: NaturalHistoryField,
    locale: string = 'pt-BR'
): string {
    const language = locale === 'fr' ? 'fr' : 'pt-BR';
    return FIELD_LABELS[language][field] || field;
}

export function getNaturalHistoryLabel(
    field: NaturalHistoryField,
    value: any,
    locale: string = 'pt-BR'
): string {
    const language = locale === 'fr' ? 'fr' : 'pt-BR';
    const fieldLabels = LABELS[language][field] || {};
    return fieldLabels[value] || value || '';
}
